export const AUTH_TOKEN_KEY = 'ami:auth-token'
export const AUTH_USER_KEY = 'ami:cur-user'
